<template>
	<div v-show="infoData.length || totalData.length" class="info-card flex">
		<div v-if="infoData.length" class="item flex-grow">
			<ul>
				<li v-for="(item, i) in infoData" :key="i" class="flex">
					<label>{{item.name}}：</label>
					<p class="flex-grow">{{item.value}}</p>
				</li>
			</ul>
		</div>
		<div v-for="(item, i) in totalData" :key="i" class="item total flex-column flex-center flex-grow">
			<div :style="{'color': item.color ? `var(--color-${item.color})` : '#000'}">{{item.value}}</div>
			<p>{{item.name}}</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'infoCard',
		
		props: {
			code: String,
			id: [String, Number, Boolean],
			info: Array,
			total: Array
		},

		data() {
			return {
				asyncInfo: [],
				asyncTotal: []
			}
		},

		computed: {
			infoData() {
				return this.info || this.asyncInfo;
			},

			totalData() {
				return this.total || this.asyncTotal;
			}
		},

		watch: {
			id: {
				handler() {
					if (!this.code) return;
					this.request({
						url: '/system/cardInfo',
						data: {
							card_code: this.code,
							id: this.id
						},
						success: data => {
							this.asyncInfo = data.info || [];
							this.asyncTotal = data.total || [];
						}
					});
				},
				immediate: true
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.info-card  {
		gap: 8px;

		&:nth-child(2) {
			margin-top: 8px;
		}

		.item {
			flex-grow: 2;
			background: #FAFAFA;

			&.total {
				flex-grow: 1;
				min-height: 64px;

				div {
					font-size: 18px;
					font-weight: bold;
				}

				p {
					margin-top: 8px;
					font-size: 12px;
					color: #999;
				}
			}

			ul {
				padding: 6px 12px;

				li {
					padding: 2px 0;
					line-height: 16px;
					font-size: 12px;
					color: #999;
				}
			}
		}
	}
</style>
